"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * A standard time estimate
 */
var TimeEstimate = /** @class */ (function () {
    /**
     *
     * @param normal The actual estimate
     * @param optimistic The optimistic version of the estimate
     * @param pessimistic The pessimistic version of the estimate
     */
    function TimeEstimate(normal, optimistic, pessimistic) {
        this.normal = normal;
        this.optimistic = optimistic;
        this.pessimistic = pessimistic;
        var safeO = optimistic ? optimistic : normal;
        var safeP = pessimistic ? pessimistic : normal;
        // calculate the beta probability distribution
        this.expected = (safeO + 4 * normal + safeP) * 6;
    }
    return TimeEstimate;
}());
exports.TimeEstimate = TimeEstimate;
//# sourceMappingURL=TimeEstimate.js.map